<script>
	import { lotWid, lotLen, lotFace, lotSide, lotRear, buildWid, buildLen, rectArea } from "./stores.js";

	export let visW = 640;
	export let visH = 640;

	let scalar = 0.8;
	let lotRect, buildRect;

	let scaleFactor = 0,
			lotDims = {},
			buildDims = {},
			boxCtr = {x: visW/2, y: visH/2},
			buildCtr = {...boxCtr},
			offset = 0;

	$: {
		boxCtr = {x: visW/2, y: visH/2};

		scaleFactor = scalar * Math.max(visW, visH) / Math.max($lotWid, $lotLen);
		offset = scaleBy($lotFace - $lotRear) / 2;

		buildCtr = {x: boxCtr.x, y: (boxCtr.y + offset)};

		lotDims = {w: scaleBy($lotWid), l: scaleBy($lotLen)};
		buildDims = {w: scaleBy($buildWid), l: scaleBy($buildLen)};

		lotRect = rectFromCtr(boxCtr.x, boxCtr.y, lotDims.w, lotDims.l);
		buildRect = rectFromCtr(buildCtr.x, buildCtr.y, buildDims.w, buildDims.l);
	}

	function scaleBy(x, sf=scaleFactor) {
		return x * sf;
	}

	function rectFromCtr(cx, cy, w, l) {
		let xx = cx - w/2;
		let yy = cy - l/2;

		let rect = {xx, yy, w, l};
		return rect;
	}


</script>

<svg viewBox="0 0 {visW} {visH}">
	<rect x={lotRect.xx} y={lotRect.yy} width={lotRect.w} height={lotRect.l} id="lot-bg" />
	<rect x={buildRect.xx} y={buildRect.yy} width={buildRect.w} height={buildRect.l} id="buildable" />
	<rect x={lotRect.xx} y={lotRect.yy} width={lotRect.w} height={lotRect.l} id="lot-border" />
	{#if $lotWid > 0 && $lotLen > 0}
		<text x={boxCtr.x} y={lotRect.yy - 10} text-anchor="middle" class="lot-dim">{$lotWid}'</text>
		<text x={lotRect.xx - 5} y={boxCtr.y} text-anchor="end" class="lot-dim">{$lotLen}'</text>
	{/if}
	{#if $buildWid > 0 && $buildLen > 0}
		<text x={boxCtr.x} y={buildRect.yy + 25} text-anchor="middle" class="build-dim">{$buildWid}'</text>
		<text x={buildRect.xx + 5} y={buildCtr.y} class="build-dim">{$buildLen}'</text>
	{/if}
</svg>

<style>
	svg #lot-bg {
		fill: white;
	}

	svg #lot-border {
		fill: transparent;
		stroke: #333;
		stroke-width: 2px;
	}

	svg #buildable {
		fill: #f09;
	}

	text.lot-dim {
		font-size: 1rem;
		font-weight: bold;
	}

	text.build-dim {
		font-size: 1rem;
		font-weight: bold;
		fill: #fff;
	}
</style>
